export var version = '3.7.3';
//# sourceMappingURL=version.js.map